// extracted by mini-css-extract-plugin
export var feedbackContainer = "feedbacks-module--feedbackContainer--34BfZ";
export var section = "feedbacks-module--section--i3R5m";
export var paragraph = "feedbacks-module--paragraph--M6koq";
export var name = "feedbacks-module--name--0qJa5";
export var button = "feedbacks-module--button--3e+DD";